import { render, staticRenderFns } from "./Sample_manage.vue?vue&type=template&id=13fb8030&scoped=true"
import script from "./Sample_manage.vue?vue&type=script&lang=js"
export * from "./Sample_manage.vue?vue&type=script&lang=js"
import style0 from "./Sample_manage.vue?vue&type=style&index=0&id=13fb8030&prod&lang=css"
import style1 from "./Sample_manage.vue?vue&type=style&index=1&id=13fb8030&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fb8030",
  null
  
)

export default component.exports